<!--
  toast.show('toast text')
  toast.show('toast text', { duration: Infinity, icon: 'success', className: '' })
  toast.success('Success')
  toast.error('Failed')
  toast.spin('Loading', className: '')
  toast.hide()
  // className is additional class for UI if needed
-->

<template>
  <transition name="fade">
    <div>
      <div :class="className" v-if="visible">
        <div>
          <spin v-if="isSpin"></spin>
          <icon v-if="isOthers" :name="icon"></icon>
          <p v-if="message">{{ message }}</p>
        </div>
      </div>
      <div v-if="visible && isSpin" class="toast-spin-bg"></div>
    </div>
  </transition>
</template>

<script>
import spin from './spin'
import icon from './icon'

export default {
  components: {
    spin,
    icon
  },

  data: () => ({
    message: null,
    visible: false,
    icon: null,
    className: ''
  }),

  computed: {
    isSpin () {
      return this.icon === 'spin'
    },

    isOthers () {
      return this.icon && this.icon !== 'spin'
    }
  },

  methods: {
    show (message, options = {}) {
      this.hide(false)

      const {
        duration = 2000,
        icon,
        className
      } = options

      this.message = message
      this.icon = icon
      this.visible = true
      this.className = ['toast', className]

      /**
        * NOTE:
        * if duration is `Infinity`, return `void` instead of `Promise`
        */
      if (duration === Infinity) return

      return new Promise(resolve => {
        /**
          * resolve promise and destory method itself
          */
        this._resolve = resolve

        this._timer = setTimeout(() => {
          this.hide(true)
        }, duration)
      })
    },

    /**
      * @return {Promise<void>}
      * the returned promise will always resolve after {duration}ms.
      * even if
      */
    success (message, options = {}) {
      return this.show(message, {
        ...options,
        icon: 'success'
      })
    },

    error (message, options = {}) {
      return this.show(message, {
        ...options,
        icon: 'error'
      })
    },

    spin (message, className = '') {
      return this.show(message, {
        icon: 'spin',
        duration: Infinity,
        className
      })
    },

    /**
      * hide the toast, resolve promise and clean
      * @param {boolean} natural - if toast is hide after timeout: natural = true
      */
    hide (natural = false) {
      // hide UI
      this.visible = false

      // resolve promise and rm resolver
      this._resolve && this._resolve(natural)
      this._resolve = null

      // clear timer
      clearTimeout(this._timer)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_toast.vue